
$('.js-controllable-video').each(function(){
    const container = $(this)
    const video = $(this).find('video')
    const filter = $(this).find('.filter')
    const play_ic = $(this).find('.js-play-ic')
    const pause_ic = $(this).find('.js-pause-ic')
    const on_volume_ic = $(this).find('.js-on-volume-ic')
    const off_volume_ic = $(this).find('.js-off-volume-ic')
    const progress = $(this).find('.js-progress')

    video.click(function(){
        let playing = container.hasClass('playing')

        if (playing){
            container.removeClass('playing')
            filter.css('opacity', 1)
            play_ic.fadeIn()
            pause_ic.fadeOut()
            video[0].pause()
        } else {
            container.addClass('playing')
            filter.css('opacity', 0)
            play_ic.fadeOut()
            pause_ic.fadeIn()
            video[0].play()
        }
    })

    on_volume_ic.click(function (){
        console.log('on')
        on_volume_ic.hide()
        off_volume_ic.fadeIn()
        video[0].muted = false
    })
    off_volume_ic.click(function (){
        on_volume_ic.fadeIn()
        off_volume_ic.hide()
        video[0].muted = true
        console.log('off')
    })

    video[0].addEventListener('timeupdate', function(){
        const videoDuration = video[0].duration
        let videoProgress = video[0].currentTime
        progress.css('width', (videoProgress * 100 / videoDuration) + '%' )
    });


})

